// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","selected-color":"#d9f2ff","selected":"DiseaseInput_selected__2k926"};